import testDataFromServer from '../actions/socket';

const initialState = {
  data: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case testDataFromServer:
      return {
        ...state,
        data: action.data
      };
    default:
      return state;
  }
};
